import { IMissionPlan } from '../missionPlan/IMissionPlan'
import { MissionPlanUiState } from '../../ui/MissionPlanUiState'
import { IGliderConfig, getDefaultGliderConfig } from './IGliderConfig'
import { SimulationMode } from '@/enum/SimulationMode'

export interface ISmartSimulationBase {
  templateSimId: number | null
  processing_mode: string
  mission_start_date: string
  glider_type: string
  battery_type: string
  bms_type: string
  enable_science_files: boolean
  surfacing_time: number
  current_cycle: number
}

export function getDefaultSmartSimulationBase({
  templateSimId = null,
  processing_mode = SimulationMode.simulator,
  mission_start_date = '',
  glider_type = 'SEAEXPLORER',
  battery_type = 'pack 18650',
  bms_type = 'neogy',
  enable_science_files = false,
  surfacing_time = 300,
  current_cycle = 0,
} = {}) {
  return {
    templateSimId,
    processing_mode,
    mission_start_date,
    glider_type,
    battery_type,
    bms_type,
    enable_science_files,
    surfacing_time,

    current_cycle,
  } as ISmartSimulationBase
}

export function isReadyForSimulationBase(data: ISmartSimulationBase | null): Array<string> {
  const simuErrorCode = []
  if ((data?.mission_start_date ?? '') == '') simuErrorCode.push('MissingStartDate')
  return simuErrorCode
}
